import {lazy} from 'react';

export const LeftNavigationLazy = lazy(() => import(/* webpackChunkName: "leftNavigation" */ '.'));
